export default "__VITE_ASSET__CjmEku4E__"